import { render, staticRenderFns } from "./pqrsMaintenance.vue?vue&type=template&id=05f2001e&"
import script from "./pqrsMaintenance.vue?vue&type=script&lang=js&"
export * from "./pqrsMaintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports